import {handleLogout} from "components/utils";
import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Row, Table} from "react-bootstrap";
import axios from "axios";
import {SERVICES} from "../permissions";
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions, TableBody,
    TableColumnType,
    TableHeader
} from "react-bs-datatable";
import Editor from "react-simple-wysiwyg";
import {RichEditor} from "../ipd/consentForms/RichEditor";

export const UpdateDiagnosticServicesTemplateView = (props: { cookieEntityQr: string, id: string, postAction: any }) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const [parameters, setParameters] = useState([]);
    const [notes, setNotes] = useState(null);
    const [notesId, setNotesId] = useState(null);
    const [addParam, setAddParam] = useState({});

    function fetchParameters() {
        axios.get('/api/backend/templates/param/fetch/all/' + props.cookieEntityQr + "/" + props.id)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setParameters(resp.data.filter(p => p.paramType == "VARIABLE"))
                var notes = resp.data.filter(p => p.paramType == "CONSTANT").length > 0 ? resp.data.filter(p => p.paramType == "CONSTANT")[0] : null
                setNotes(notes.description)
                setNotesId(notes.id)
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
            })
    }

    const handleRemove = (id) => {
        setErrorMessage("")
        axios.post('/api/backend/templates/param/remove/' + id)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                fetchParameters()
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
                setErrorMessage("* Something went wrong! Please try again in sometime.")
            })
    }

    const handleAdd = () => {
        setErrorMessage("")
        axios.post('/api/backend/templates/param/create/', {
            entityQr: props.cookieEntityQr,
            name: addParam["name"],
            templateId: props.id,
            units: addParam["units"],
            bioReference: addParam["bioReference"],
            type: "User",
            paramType: "VARIABLE",
            rangeStart: addParam["rangeStart"],
            rangeEnd: addParam["rangeEnd"]
        })
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                fetchParameters()
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
                setErrorMessage("* Something went wrong! Please try again in sometime.")
            })
    }

    const handleAddNotes = () => {
        setErrorMessage("")
        const urlPath = notesId ? "update/" + notesId : "create/"
        axios.post('/api/backend/templates/param/' + urlPath, {
            entityQr: props.cookieEntityQr,
            name: "Notes",
            templateId: props.id,
            type: "User",
            paramType: "CONSTANT",
            description: notes
        })
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                fetchParameters()
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
                setErrorMessage("* Something went wrong! Please try again in sometime.")
            })
    }

    const handleChange = (e) => {
        var bioref = null
        if (e.target.name == "rangeStart") {
            if (addParam["rangeEnd"]) {
                bioref = e.target.value + " - " + addParam["rangeEnd"]
            } else {
                bioref = ">= " + e.target.value
            }
        }
        if (e.target.name == "rangeEnd") {
            if (addParam["rangeStart"]) {
                bioref = addParam["rangeStart"] + " - " + e.target.value
            } else {
                bioref = "<= " + e.target.value
            }
        }
        if (bioref) {
            setAddParam({
                ...addParam,
                [e.target.name]: e.target.value,
                bioReference: bioref
            });
        } else {
            setAddParam({
                ...addParam,
                [e.target.name]: e.target.value,
            });
        }
    };


    useEffect(() => {
        if (props.id) {
            fetchParameters()
        }
    }, [props.id])


    return (
        <div className="min-vh-100">
            <table className="table">
                <thead>
                <th>Parameter Name</th>
                <th>Units</th>
                <th>Range Start</th>
                <th>Range End</th>
                <th>bioReference</th>
                <th>Action</th>
                </thead>
                <tbody>
                {parameters && parameters.map(p => {
                    return <tr key={p.id}>
                        <td>
                            {p.name}
                        </td>
                        <td>
                            {p.units}
                        </td>
                        <td>
                            {p.rangeStart}
                        </td>
                        <td>
                            {p.rangeEnd}
                        </td>
                        <td>
                            {p.bioReference}
                        </td>
                        <td>
                            {p.entityQr != "system" && <a href="#/" className="remove text-decoration-none"
                                                          onClick={() => handleRemove(p.id)}>X</a>}
                        </td>
                    </tr>
                })}
                <tr>
                    <td>
                        <input className="form-control form-control-sm" name="name" value={addParam && addParam["name"]}
                               onChange={e => handleChange(e)}/>
                    </td>
                    <td>
                        <input className="form-control form-control-sm" name="units"
                               value={addParam && addParam["units"]} onChange={e => handleChange(e)}/>
                    </td>
                    <td>
                        <input className="form-control form-control-sm" name="rangeStart"
                               value={addParam && addParam["rangeStart"]} onChange={e => handleChange(e)}/>
                    </td>
                    <td>
                        <input className="form-control form-control-sm" name="rangeEnd"
                               value={addParam && addParam["rangeEnd"]} onChange={e => handleChange(e)}/>
                    </td>
                    <td>
                        <input className="form-control form-control-sm" name="bioReference"
                               value={addParam && addParam["bioReference"]} onChange={e => handleChange(e)}/>
                    </td>
                    <td>
                        <button className="btn btn-sm btn-warning text-white" onClick={() => handleAdd()}>+ Add</button>
                    </td>
                </tr>
                <tr>
                    <td colSpan={5}>
                        <Form.Group controlId="notes">
                            <RichEditor data={notes} setData={setNotes} height={300}
                                        placeholder={"Write Notes to be printed on all reports"}/>
                        </Form.Group></td>
                    <td>
                        <button className="btn btn-sm btn-warning text-white"
                                onClick={() => handleAddNotes()}>{notesId ? <>Update</> : <>+ Add</>}</button>
                    </td>
                </tr>
                </tbody>
            </table>
            {errorMessage &&
                <div className="text-danger fs-5">{errorMessage}</div>
            }

        </div>
    );
};
